module.exports = "mutation UpdateHomepageTab($data:UpdateHomepageTabInput!){updateHomepageTab(data:$data){success}}"